<template>
  <div>

      <li class="nav-item" v-if="!hasChildren">
        <a class="nav-link font-weight-bolder"
           style="color: #343a40;"
           :class="selected !== null && selected.id===nodes.id ? 'text-white bg-danger': ''" role="button"
           @click="clickMenu(nodes)">{{ nodes.name }}</a>
      </li>

      <li v-else class="nav-item dropdown btn-group">
        <a class="nav-link dropdown-toggle font-weight-bold"
           :class="selected !== null && selected.category_id===nodes.id ? 'text-white bg-danger': ''"
           href="#" id="navbarDropdown"
           style="color: #343a40;"
           role="button"
           data-toggle="dropdown"
           aria-haspopup="true"
           aria-expanded="false">
          {{ nodes.name }}
        </a>
        <div class="dropdown-menu" aria-labelledby="navbarDropdown">
          <tree-nav v-for="node in nodes.sub_categories" :nodes="node"
                    :key="node.id"
                    :selected="selected"
                    @menuClick="(nodes)=>$emit('menuClick',nodes)"
          />
        </div>
      </li>


  </div>
</template>

<script>
export default {
  name: 'TreeNav',
  props: {
    nodes: {
      type: Object,
      default: null,
    },
    selected: {
      default: null,
    },
  },
  computed: {
    hasChildren() {
      let {sub_categories} = this.nodes;
      return sub_categories && sub_categories.length > 0;
    },
  },
  methods: {
    clickMenu(node) {
      if (!node.hasChildren) {
        this.$emit('menuClick', node);
      }
    },
  },
};
</script>

<style scoped>
.red {
  color: #42b983;
}
</style>
